import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';

import getMetaTagData from '../../../src/common/services/getMetaTagData';
function PlayZoneEvent({ metaTagData, jWTCheck }) {
  const handle = (e) => {
    e.preventDefault();

    alert('Part1 이벤트는 종료되었습니다.\nPart2 이벤트를 참여해주세요!');
    return false;
  };

  useEffect(() => {
    // const talk = document.querySelector('.talk_popup');
    // talk.addEventListener('click', (e) => {
    //   e.preventDefault();
    //   window.open('https://www.sbs.co.kr/playtalk/module.html?code=playtalkevent1', '플레이톡', 'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no');
  });

  //  })

  // part1 플레이톡
  // const handleClick = () => {
  //   //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
  //   window.open('https://www.sbs.co.kr/playtalk/module.html?code=playtalkevent1', '플레이톡', 'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no');
  // };

  return (
    <>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      {/*<!-- 컨텐츠영역 -->*/}
      <div id="container" className="contents_sbsplay">
        <div className="sbsplayEventContents">
          {/*<!-- 페이지 명 클래스  -->*/}
          <div
            className="sbsplayEventTop_w"
            style={{ backgroundImage: `url('/images/bg_tree2.png')` }}
          >
            <em className="sbsplayEventTop_cont">
              <img src="/images/event_top_img2.png" alt="" />
            </em>
          </div>
          <div className="sbsplayEventMiddle_w">
            <ul className="sbsplayEventTab_w">
              <li className="sbsplayEventTab_inner">
                <a href="#event01" className="sbsplayEventTab_event1">
                  <img src="/images/tab_text01.png" alt="7개의 미션" />
                </a>
              </li>
              <li className="sbsplayEventTab_inner">
                <a href="#event02" className="sbsplayEventTab_event2">
                  <img
                    src="/images/tab_text02.png"
                    alt="AllVOD 리뉴얼 축하파티"
                  />
                </a>
              </li>
              <li className="sbsplayEventTab_inner">
                <a href="#event03" className="sbsplayEventTab_event3">
                  <img
                    src="/images/tab_text03.png"
                    alt="플레이톡 참여 인증 이벤트"
                  />
                </a>
              </li>
            </ul>
            <div className="sbsplayEventContArea">
              <div className="sbsplayEventBox_w event_type01" id="event01">
                <div className="sbsplayEventBox_top">
                  <em className="iconSvg_eventTitle01">
                    <i className="hide">7개의 미션</i>
                  </em>
                  <div className="sbsplayEventBoxTop-text">
                    <img src="/images/text_surprise.png" alt="Surprise!" />
                  </div>
                </div>
                <div className="sbsplayEventBox_tabs">
                  <a
                    href="#none"
                    className="sbsplayEventBox_tab"
                    onClick={handle}
                  >
                    {/*<!-- current 추가 -->*/}
                    <span className="sbsplayEventBox_tabPart">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="tabPart01"
                        width="81"
                        height="36.002"
                        viewBox="0 0 81 36.002"
                      >
                        <path
                          id="Part_1"
                          data-name="Part 1"
                          d="M-26-13.8a6.57,6.57,0,0,1-.81,3.233A5.961,5.961,0,0,1-29.3-8.207a8.737,8.737,0,0,1-4.165.9h-3.066V0h-4.946V-20.358h8.011a9.1,9.1,0,0,1,4.107.841A5.77,5.77,0,0,1-26.84-17.2,6.758,6.758,0,0,1-26-13.8Zm-7.838,2.552a2.945,2.945,0,0,0,2.111-.667,2.492,2.492,0,0,0,.694-1.885,2.492,2.492,0,0,0-.694-1.885,2.945,2.945,0,0,0-2.111-.667h-2.69v5.1Zm9.429,3.132a9.693,9.693,0,0,1,.94-4.379,7.024,7.024,0,0,1,2.56-2.9A6.669,6.669,0,0,1-17.3-16.414a6.2,6.2,0,0,1,2.993.7,5.119,5.119,0,0,1,1.981,1.827v-2.291h4.946V0h-4.946V-2.291a5.346,5.346,0,0,1-2.01,1.827,6.2,6.2,0,0,1-2.993.7A6.549,6.549,0,0,1-20.911-.8a7.108,7.108,0,0,1-2.56-2.929A9.785,9.785,0,0,1-24.411-8.12Zm12.089.029a4.061,4.061,0,0,0-1.027-2.929,3.332,3.332,0,0,0-2.5-1.073,3.353,3.353,0,0,0-2.5,1.059A4.009,4.009,0,0,0-19.378-8.12a4.113,4.113,0,0,0,1.027,2.943,3.311,3.311,0,0,0,2.5,1.088,3.332,3.332,0,0,0,2.5-1.073A4.061,4.061,0,0,0-12.321-8.091ZM1.156-13.485a6.532,6.532,0,0,1,2.169-2.1,5.582,5.582,0,0,1,2.892-.769v5.249H4.858a4.159,4.159,0,0,0-2.776.8,3.548,3.548,0,0,0-.925,2.8V0H-3.789V-16.182H1.156Zm16.428,9.28V0H15.068a6.148,6.148,0,0,1-4.194-1.32q-1.5-1.32-1.5-4.307v-6.438H7.4v-4.118H9.37v-3.944h4.946v3.944h3.239v4.118H14.316v6.5a1.361,1.361,0,0,0,.347,1.044,1.691,1.691,0,0,0,1.157.319Zm8.405-23.774V-35.77H39.526V0h-8.7V-27.979Z"
                          transform="translate(41.474 35.77)"
                        />
                      </svg>
                    </span>
                    <span className="sbsplayEventBox_tabDate">12.11~1.11</span>
                  </a>
                  <a href="#none" className="sbsplayEventBox_tab current">
                    {/*<!-- current 추가 -->*/}
                    <span className="sbsplayEventBox_tabPart">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="tabPart02"
                        width="92"
                        height="36"
                        viewBox="0 0 92 36"
                      >
                        <path
                          id="Part_2"
                          data-name="Part 2"
                          d="M-30.876-14.29a6.352,6.352,0,0,1-.8,3.164,5.885,5.885,0,0,1-2.472,2.313,8.793,8.793,0,0,1-4.139.88h-3.046V-.781h-4.915V-20.7h7.961a9.157,9.157,0,0,1,4.081.823,5.7,5.7,0,0,1,2.5,2.27A6.534,6.534,0,0,1-30.876-14.29Zm-7.789,2.5a2.956,2.956,0,0,0,2.1-.653,2.418,2.418,0,0,0,.69-1.845,2.418,2.418,0,0,0-.69-1.845,2.956,2.956,0,0,0-2.1-.653h-2.673v4.995ZM-29.3-8.728a9.366,9.366,0,0,1,.934-4.285,6.909,6.909,0,0,1,2.543-2.838,6.7,6.7,0,0,1,3.593-.993,6.235,6.235,0,0,1,2.975.681,5.057,5.057,0,0,1,1.969,1.788v-2.242h4.915V-.781h-4.915V-3.023a5.284,5.284,0,0,1-2,1.788,6.235,6.235,0,0,1-2.975.681,6.582,6.582,0,0,1-3.564-1.008,6.99,6.99,0,0,1-2.543-2.866A9.454,9.454,0,0,1-29.3-8.728Zm12.013.028a3.938,3.938,0,0,0-1.02-2.866,3.335,3.335,0,0,0-2.486-1.05,3.357,3.357,0,0,0-2.486,1.036,3.888,3.888,0,0,0-1.02,2.852,3.989,3.989,0,0,0,1.02,2.881,3.314,3.314,0,0,0,2.486,1.064A3.335,3.335,0,0,0-18.3-5.833,3.938,3.938,0,0,0-17.282-8.7Zm13.393-5.279a6.447,6.447,0,0,1,2.156-2.058,5.613,5.613,0,0,1,2.874-.752v5.137H-.21a4.177,4.177,0,0,0-2.759.78,3.441,3.441,0,0,0-.92,2.739V-.781H-8.8V-16.617h4.915ZM12.435-4.9V-.781h-2.5A6.172,6.172,0,0,1,5.768-2.072,5.3,5.3,0,0,1,4.273-6.287v-6.3H2.319v-4.03H4.273v-3.86H9.188v3.86h3.219v4.03H9.188V-6.23a1.32,1.32,0,0,0,.345,1.022,1.7,1.7,0,0,0,1.15.312ZM21.37-7.351q1.651-1.295,1.505-1.2,4.759-3.884,7.5-6.378a30.793,30.793,0,0,0,4.638-5.227,9.369,9.369,0,0,0,1.894-5.323,4.645,4.645,0,0,0-.923-3.069,3.4,3.4,0,0,0-2.768-1.1,3.433,3.433,0,0,0-2.889,1.367,6.243,6.243,0,0,0-1.044,3.86H21.273a13.45,13.45,0,0,1,1.772-6.809,10.248,10.248,0,0,1,4.419-4.028,14.1,14.1,0,0,1,6.094-1.295q5.779,0,8.717,2.925A10.288,10.288,0,0,1,45.214-26a14.842,14.842,0,0,1-3.545,9.519,51.922,51.922,0,0,1-9.032,8.56H45.748v6.665H21.37Z"
                          transform="translate(46.252 36.554)"
                        />
                      </svg>
                    </span>
                    <span className="sbsplayEventBox_tabDate">4.1~4.30</span>
                  </a>
                </div>
                <div className="sbsplayEventBox_cont">
                  <img src="/images/open_event01.png" alt="" />
                </div>
                <div className="sbsplayEventBox_bottom">
                  <div className="sbsplayEventBoxBottom_inner">
                    <div className="sbsplayEventBox_btn_w">
                      <a
                        href="https://www.sbs.co.kr/sbsplay/event/2023/7mission/?utm_source=playzone&utm_medium=button"
                        target="_blank"
                        className="sbsplayEventBox_btn"
                      >
                        <span className="eventBox_btnSubmit">
                          <i className="hide">참여하기</i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sbsplayEventBox_w event_type02" id="event02">
                <div className="sbsplayEventBox_top">
                  <em className="iconSvg_eventTitle02">
                    <i className="hide">AllVOD 리뉴얼 축하파티</i>
                  </em>
                  <div className="sbsplayEventBoxTop-text">
                    <img src="/images/text_wow.png" alt="Surprise!" />
                  </div>
                </div>
                <div className="sbsplayEventBox_tabs">
                  <a
                    href="#none"
                    className="sbsplayEventBox_tab"
                    onClick={handle}
                  >
                    {/*<!-- current 추가 -->*/}
                    <span className="sbsplayEventBox_tabPart">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="tabPart01"
                        width="44"
                        height="38"
                        viewBox="0 0 44 38"
                      >
                        <path
                          id="_1부"
                          data-name="1부"
                          d="M-22.389-28.044V-35.77H-8.9V-.3h-8.668V-28.044ZM.221-12.486V-24.057H3.739v3.047H14.293v-3.047h3.518v11.571Zm14.072-5.561H3.739v2.626H14.293ZM10.747-6.968v9.2H7.229v-9.2H-3.579V-9.931h25.19v2.963Z"
                          transform="translate(22.389 35.77)"
                        />
                      </svg>
                    </span>
                    <span className="sbsplayEventBox_tabDate">12.11~1.11</span>
                  </a>
                  <a href="#none" className="sbsplayEventBox_tab current">
                    {/*<!-- current 추가 -->*/}
                    <span className="sbsplayEventBox_tabPart">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="tabPart02"
                        width="53"
                        height="39"
                        viewBox="0 0 53 39"
                      >
                        <path
                          id="_2부"
                          data-name="2부"
                          d="M-26.579-6.791q1.655-1.32,1.509-1.222,4.771-3.959,7.522-6.5A31.225,31.225,0,0,0-12.9-19.84,9.649,9.649,0,0,0-11-25.265a4.787,4.787,0,0,0-.925-3.128A3.385,3.385,0,0,0-14.7-29.517a3.421,3.421,0,0,0-2.9,1.393,6.44,6.44,0,0,0-1.047,3.934h-8.034a13.882,13.882,0,0,1,1.777-6.94,10.337,10.337,0,0,1,4.431-4.105,13.945,13.945,0,0,1,6.11-1.32q5.794,0,8.74,2.981A10.58,10.58,0,0,1-2.673-25.8a15.275,15.275,0,0,1-3.554,9.7,52.432,52.432,0,0,1-9.056,8.724H-2.138V-.585H-26.579ZM4.937-12.355V-23.992H8.455v3.065H19.007v-3.065h3.518v11.637Zm14.07-5.593H8.455v2.641H19.007ZM15.461-6.8V2.446H11.944V-6.8H1.138v-2.98H26.323V-6.8Z"
                          transform="translate(26.677 36.554)"
                        />
                      </svg>
                    </span>
                    <span className="sbsplayEventBox_tabDate">4.1~4.30</span>
                  </a>
                </div>
                <div className="sbsplayEventBox_cont">
                  <img src="/images/open_event02.png" alt="" />
                </div>
                <div className="sbsplayEventBox_bottom">
                  <div className="sbsplayEventBoxBottom_inner">
                    <div className="sbsplayEventBox_btn_w">
                      <a
                        href="https://allvod.sbs.co.kr/2023renewalparty2.html?utm_source=playzone&utm_medium=button&utm_campaign=brandevent2#100won"
                        target="_blank"
                        className="sbsplayEventBox_btn"
                      >
                        <span className="eventBox_btnSubmit">
                          <i className="hide">참여하기</i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sbsplayEventBox_w event_type03" id="event03">
                <div className="sbsplayEventBox_top">
                  <em className="iconSvg_eventTitle03">
                    <i className="hide">플레이톡 참여 인증 이벤트</i>
                  </em>
                  <div className="sbsplayEventBoxTop-text">
                    <img src="/images/text_like.png" alt="Surprise!" />
                  </div>
                </div>
                <div className="sbsplayEventBox_tabs">
                  <a
                    href="#none"
                    className="sbsplayEventBox_tab"
                    onClick={handle}
                  >
                    {/*<!-- current 추가 -->*/}
                    <span className="sbsplayEventBox_tabPart">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="tabPart01"
                        width="81"
                        height="36.002"
                        viewBox="0 0 81 36.002"
                      >
                        <path
                          id="Part_1"
                          data-name="Part 1"
                          d="M-26-13.8a6.57,6.57,0,0,1-.81,3.233A5.961,5.961,0,0,1-29.3-8.207a8.737,8.737,0,0,1-4.165.9h-3.066V0h-4.946V-20.358h8.011a9.1,9.1,0,0,1,4.107.841A5.77,5.77,0,0,1-26.84-17.2,6.758,6.758,0,0,1-26-13.8Zm-7.838,2.552a2.945,2.945,0,0,0,2.111-.667,2.492,2.492,0,0,0,.694-1.885,2.492,2.492,0,0,0-.694-1.885,2.945,2.945,0,0,0-2.111-.667h-2.69v5.1Zm9.429,3.132a9.693,9.693,0,0,1,.94-4.379,7.024,7.024,0,0,1,2.56-2.9A6.669,6.669,0,0,1-17.3-16.414a6.2,6.2,0,0,1,2.993.7,5.119,5.119,0,0,1,1.981,1.827v-2.291h4.946V0h-4.946V-2.291a5.346,5.346,0,0,1-2.01,1.827,6.2,6.2,0,0,1-2.993.7A6.549,6.549,0,0,1-20.911-.8a7.108,7.108,0,0,1-2.56-2.929A9.785,9.785,0,0,1-24.411-8.12Zm12.089.029a4.061,4.061,0,0,0-1.027-2.929,3.332,3.332,0,0,0-2.5-1.073,3.353,3.353,0,0,0-2.5,1.059A4.009,4.009,0,0,0-19.378-8.12a4.113,4.113,0,0,0,1.027,2.943,3.311,3.311,0,0,0,2.5,1.088,3.332,3.332,0,0,0,2.5-1.073A4.061,4.061,0,0,0-12.321-8.091ZM1.156-13.485a6.532,6.532,0,0,1,2.169-2.1,5.582,5.582,0,0,1,2.892-.769v5.249H4.858a4.159,4.159,0,0,0-2.776.8,3.548,3.548,0,0,0-.925,2.8V0H-3.789V-16.182H1.156Zm16.428,9.28V0H15.068a6.148,6.148,0,0,1-4.194-1.32q-1.5-1.32-1.5-4.307v-6.438H7.4v-4.118H9.37v-3.944h4.946v3.944h3.239v4.118H14.316v6.5a1.361,1.361,0,0,0,.347,1.044,1.691,1.691,0,0,0,1.157.319Zm8.405-23.774V-35.77H39.526V0h-8.7V-27.979Z"
                          transform="translate(41.474 35.77)"
                        />
                      </svg>
                    </span>
                    <span className="sbsplayEventBox_tabDate">12.11~1.11</span>
                  </a>
                  <a href="#none" className="sbsplayEventBox_tab current">
                    {/*<!-- current 추가 -->*/}
                    <span className="sbsplayEventBox_tabPart">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="tabPart02"
                        width="92"
                        height="36"
                        viewBox="0 0 92 36"
                      >
                        <path
                          id="Part_2"
                          data-name="Part 2"
                          d="M-30.876-14.29a6.352,6.352,0,0,1-.8,3.164,5.885,5.885,0,0,1-2.472,2.313,8.793,8.793,0,0,1-4.139.88h-3.046V-.781h-4.915V-20.7h7.961a9.157,9.157,0,0,1,4.081.823,5.7,5.7,0,0,1,2.5,2.27A6.534,6.534,0,0,1-30.876-14.29Zm-7.789,2.5a2.956,2.956,0,0,0,2.1-.653,2.418,2.418,0,0,0,.69-1.845,2.418,2.418,0,0,0-.69-1.845,2.956,2.956,0,0,0-2.1-.653h-2.673v4.995ZM-29.3-8.728a9.366,9.366,0,0,1,.934-4.285,6.909,6.909,0,0,1,2.543-2.838,6.7,6.7,0,0,1,3.593-.993,6.235,6.235,0,0,1,2.975.681,5.057,5.057,0,0,1,1.969,1.788v-2.242h4.915V-.781h-4.915V-3.023a5.284,5.284,0,0,1-2,1.788,6.235,6.235,0,0,1-2.975.681,6.582,6.582,0,0,1-3.564-1.008,6.99,6.99,0,0,1-2.543-2.866A9.454,9.454,0,0,1-29.3-8.728Zm12.013.028a3.938,3.938,0,0,0-1.02-2.866,3.335,3.335,0,0,0-2.486-1.05,3.357,3.357,0,0,0-2.486,1.036,3.888,3.888,0,0,0-1.02,2.852,3.989,3.989,0,0,0,1.02,2.881,3.314,3.314,0,0,0,2.486,1.064A3.335,3.335,0,0,0-18.3-5.833,3.938,3.938,0,0,0-17.282-8.7Zm13.393-5.279a6.447,6.447,0,0,1,2.156-2.058,5.613,5.613,0,0,1,2.874-.752v5.137H-.21a4.177,4.177,0,0,0-2.759.78,3.441,3.441,0,0,0-.92,2.739V-.781H-8.8V-16.617h4.915ZM12.435-4.9V-.781h-2.5A6.172,6.172,0,0,1,5.768-2.072,5.3,5.3,0,0,1,4.273-6.287v-6.3H2.319v-4.03H4.273v-3.86H9.188v3.86h3.219v4.03H9.188V-6.23a1.32,1.32,0,0,0,.345,1.022,1.7,1.7,0,0,0,1.15.312ZM21.37-7.351q1.651-1.295,1.505-1.2,4.759-3.884,7.5-6.378a30.793,30.793,0,0,0,4.638-5.227,9.369,9.369,0,0,0,1.894-5.323,4.645,4.645,0,0,0-.923-3.069,3.4,3.4,0,0,0-2.768-1.1,3.433,3.433,0,0,0-2.889,1.367,6.243,6.243,0,0,0-1.044,3.86H21.273a13.45,13.45,0,0,1,1.772-6.809,10.248,10.248,0,0,1,4.419-4.028,14.1,14.1,0,0,1,6.094-1.295q5.779,0,8.717,2.925A10.288,10.288,0,0,1,45.214-26a14.842,14.842,0,0,1-3.545,9.519,51.922,51.922,0,0,1-9.032,8.56H45.748v6.665H21.37Z"
                          transform="translate(46.252 36.554)"
                        />
                      </svg>
                    </span>
                    <span className="sbsplayEventBox_tabDate">4.1~4.30</span>
                  </a>
                </div>
                <div className="sbsplayEventBox_cont">
                  <img src="/images/open_event03.png" alt="" />
                </div>
                <div className="sbsplayEventBox_bottom">
                  <div className="sbsplayEventBoxBottom_inner">
                    <div className="sbsplayEventBox_btn_w">
                      <a
                        href="https://www.sbs.co.kr/playtalk/?utm_source=playzone&utm_medium=image&utm_id=playtalkevent&utm_content=pc"
                        target="_blank"
                        className="sbsplayEventBox_btn"
                      >
                        <span className="eventBox_btnSubmit talk_popup">
                          <i className="hide">참여하기</i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sbsplayEventBottom_w">
            <div className="bannerEvent_w">
              <a
                href="https://www.sbs.co.kr/playzone"
                className="bannerEvent_link"
              >
                <img
                  src="/images/playzone_bnr02.png"
                  alt="SBS play 브랜드를 소개합니다. GO! 즐거움을 잇다 SBS play"
                />
              </a>
            </div>
            <div className="bannerSurvey_w">
              <div className="bannerSurvey_inner">
                <p className="bannerSurvey-title">
                  SBS play에 대한 소중한 의견을 남겨주세요!
                </p>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSeiPK4cfR28WIiKZ5-RAzdZIzcCrnHHsHedJByxrJhdk8ZuSw/viewform"
                  target="_blank"
                  className="bannerSurvey-link"
                >
                  설문 참여하기
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, 'event', pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default PlayZoneEvent;
